import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { CheckmarkFilled } from '@carbon/icons-react';
import { startCase } from 'lodash-es';
import dayjs from 'dayjs';

const getStatusStyles = (statusDescription) => {
  const status = statusDescription?.toLowerCase();
  if (status === 'reviewed') {
    return {
      bg: 'bg-green-500/20',
      border: 'border-green-400/40',
      text: 'text-green-300',
      icon: CheckmarkFilled,
    };
  } else if (status === 'incomplete') {
    return {
      bg: 'bg-gray-500/20',
      border: 'border-gray-400/40',
      text: 'text-gray-300',
      icon: null,
    };
  }

  return {
    bg: 'bg-gray-500/20',
    border: 'border-gray-400/40',
    text: 'text-gray-300',
    icon: null,
  };
};

const ProgramCard = ({ app, isActive, onClick, lightMode = false }) => {
  const styles = getStatusStyles(app.status?.status?.description);
  const StatusIcon = styles.icon;

  return (
    <button
      onClick={onClick}
      className={`
        relative rounded-lg p-4 text-left transition-all duration-200 border-solid
        ${
          isActive
            ? `${styles.bg} border-2 border-blue-500 opacity-100`
            : `${styles.bg} ${styles.border} border opacity-60 hover:opacity-80`
        }
        ${!isActive ? 'cursor-pointer' : ''}
        w-full
        ${lightMode ? 'bg-gray-100 border-gray-300' : ''}
      `}
    >
      <h4 className={`font-semibold text-base leading-tight ${lightMode ? 'text-gray-900' : 'text-white'}`}>
        {app.programType?.title || 'Unknown Program'}
      </h4>

      <div className={`flex items-center gap-1.5 ${lightMode ? 'text-gray-700' : styles.text} text-sm`}>
        <span>{startCase(app.status?.status?.description?.toLowerCase() || 'N/A')}</span>
        {StatusIcon && <StatusIcon className="w-4 h-4" />}
      </div>

      <div className={`text-xs mt-5 ${lightMode ? 'text-gray-500' : 'text-gray-400'}`}>
        Updated: {app.lastModifiedDate ? dayjs(app.lastModifiedDate).format('MM/DD/YYYY') : 'N/A'}
      </div>
    </button>
  );
};

const ProgramTypesSelector = ({ applications, currentApplicationId, onProgramSwitch, lightMode = false }) => {
  const history = useHistory();

  const handleProgramClick = (appId) => {
    if (onProgramSwitch) {
      onProgramSwitch(appId);
    } else {
      history.push(`/providers/applications/${appId}?activeTab=application-details`);
    }
  };

  return (
    <>
      <h3 className={`text-[13px] leading-none tracking-1 mb-4 uppercase ${lightMode ? 'text-gray-500' : ''}`}>
        {applications?.length} Program{applications?.length !== 1 ? 's' : ''} at this location
      </h3>

      <div
        className="flex flex-col sm:grid md:gap-3 gap-2"
        style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 200px))' }}
      >
        {applications.map((app) => (
          <ProgramCard
            key={app.id}
            app={app}
            isActive={app.id === Number(currentApplicationId)}
            onClick={() => {
              if (app.id !== Number(currentApplicationId)) {
                handleProgramClick(app.id);
              }
            }}
            lightMode={lightMode}
          />
        ))}
      </div>
    </>
  );
};

export default ProgramTypesSelector;
